import { useState } from "react";
import { useMutation } from "react-query";
import { Button, Container, Link } from "basis";
import { usePageTracking } from "react-event-tracker";
import { Loading } from "components/Loading/Loading";
import { Input } from "components/Input/Input";
import { postPasswordRecovery } from "library/api";
import { isEmail } from "library/validator";
import styles from "./password-recovery.module.scss";

/**
 * This errors will override the error messages returned by the api calls
    - BAD_REQUEST
 */
const CUSTOMISE_ERROR_MESSAGES = {
  BAD_REQUEST: "Invalid email. Please check your details and try again.",
};

export const RequestResetPassword = ({ setScreen }) => {
  usePageTracking({
    page: {
      pageType: "input-page",
      siteSection: "sign-in",
      siteSubSection: "",
      pageTitle: "forget-password",
    },
    user: {
      authenticationStatus: "not logged in",
    },
  });
  const [id, setId] = useState({ value: "", success: false });
  const [error, setError] = useState(false);
  const startPasswordResetMutation = useMutation(postPasswordRecovery, {
    // if success, go to otp verification screen
    onSuccess: () => setScreen("ResetPasswordOtp", { email: id }),
    // if error, set the error message with customization
    onError: (e) => setError(CUSTOMISE_ERROR_MESSAGES[e.code] ?? e.message),
  });

  return startPasswordResetMutation.isLoading ? (
    <div className={styles.loaderWrapper}>
      <Loading />
    </div>
  ) : (
    <div className={styles.resetPasswordWrapper}>
      <h1 className="h4">Reset password</h1>
      <form
        method="post"
        onSubmit={(e) => {
          e.preventDefault();
          startPasswordResetMutation.mutate({ id: id.value });
        }}
      >
        {error && (
          <div className={`body02 ${styles.error}`} data-trackid="otp-error">
            {error}
          </div>
        )}
        <p>
          Enter your email address and we'll send a code so that you can reset
          your password.
        </p>
        <Input
          label="Email address"
          onChange={(email) => {
            setId(email);
            setError(false);
          }}
          className={styles.resetEmailInput}
          disabled={startPasswordResetMutation.isLoading}
          error={error}
          value={id.value}
          type="email"
          validator={isEmail}
        />
        <Container margin="6 0 0 0">
          <Button
            width="176"
            type="submit"
            disabled={!id.success || startPasswordResetMutation.isLoading}
          >
            Send Code
          </Button>
          <Link
            margin="0 0 0 8"
            width="176"
            appearance="secondary-button"
            variant="blue-button"
            href="/login"
            newTab={false}
          >
            Return to log in
          </Link>
        </Container>
      </form>
    </div>
  );
};
